import React from 'react'

import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { StartingStepContent } from 'common/builder/components/chart/FlowChart/components/Node/StartingStep/StartingStepContent'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { StartingStepConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartStartingStepNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartStartingStepNode'

export const StartingStep: NodeComponent<FlowChartStartingStepNode> = ({
  node,
  container,
  builderId,
}) => {
  const chartState = useFlowChartState()
  return (
    <NodeContainer
      container={container}
      builderId={builderId}
      disableFlowChartInteractions={chartState.isNoInteractions}
      nodeId={node.id}
      highlightColor={StartingStepConfig.highlightColor}
      width={StartingStepConfig.width}
    >
      <StartingStepContent node={node} />
    </NodeContainer>
  )
}
